import { APISERVICE } from "@api/RestClient";

export const updateUser = (userDetails) => {
    return new Promise((res, rej) => {
        APISERVICE.POST(`${process.env.NEXT_PUBLIC_CUSTOMERS}`, userDetails)
            .then((response) => {
                res(response);
            }).catch(function (error) {
                rej(error);
                console.error(error)
            });
    })
}

export const updateUserAddress = (address, userId) => {
    return new Promise((res, rej) => {
        APISERVICE.POST(`${process.env.NEXT_PUBLIC_CUSTOMER}/updateAddress?id=${userId}`, address)
            .then((response) => {
                res(response.data);
            }).catch(function (error) {
                rej(error);
                console.error(error)
            });
    })
}

export const updateUserBySalutation = (salutation, userId) => {
    return new Promise((res, rej) => {
        APISERVICE.POST(`${process.env.NEXT_PUBLIC_CUSTOMER}/salutations/${userId}`, { salutation })
            .then((response) => {
                res(response.data);
            }).catch((error) => {
                rej(error);
                console.error(error)
            })
    })
}

export const getUserByTenantAndMobile = (tenantId, storeId, mobile, isMinimal = false) => {
    return new Promise((res, rej) => {
        APISERVICE.GET(`${process.env.NEXT_PUBLIC_CUSTOMERS}/store?mobileNo=${mobile}&tenantId=${tenantId}&storeId=${storeId}&isMinimal=${isMinimal}`)
            .then((response) => {
                res(response);
            }).catch(function (error) {
                rej(error);
                console.error(error)
            });
    })
}

export const getUsersSalutation = (tenantId, storeId, salutation) => {
    return new Promise((res, rej) => {
        APISERVICE.GET(`${process.env.NEXT_PUBLIC_GET_BASE_CATALOG_URL}/salutations?tenantId=${tenantId}&storeId=${storeId}`)
            .then((response) => {
                res(response.data);
            }).catch(function (error) {
                rej(error);
                console.error(error)
            });
    })
}

export const getUserByGuestId = (tenantId, storeId, guestId, source) => {
    return new Promise((res, rej) => {
        APISERVICE.GET(`${process.env.NEXT_PUBLIC_CUSTOMERS}/userbyguestid?tenantId=${tenantId}&storeId=${storeId}&guestId=${guestId}`, { source: source })
            .then((response) => {
                res(response.data);
            }).catch(function (error) {
                rej(error);
                console.error(error)
            });
    })
}

export const markUserOptInForWhatsapp = (tenantId, storeId, usersList) => {
    return new Promise((res, rej) => {
        APISERVICE.PUT(`${process.env.updateaddress}/optinmobnolist/?tenantId=${tenantId}&storeId=${storeId}`, usersList)
            .then((response) => {
                res(response);
            }).catch(function (error) {
                rej(error);
                console.error(error)
            });
    })
}

export const updateUserVisitCount = (userId) => {
    return new Promise((res, rej) => {
        APISERVICE.PUT(`${process.env.NEXT_PUBLIC_CUSTOMER}/visitCount?id=${userId}`, {})
            .then((response) => {
                res(response);
            }).catch(function (error) {
                rej(error);
                console.error(error)
            });
    })
}

export const getUserSources = (tenantId, storeId) => {
    return new Promise((res, rej) => {
        APISERVICE.GET(`${process.env.NEXT_PUBLIC_CUSTOMER}/sourceOfCustomer?tenantId=${tenantId}&storeId=${storeId}`)
            .then((response) => {
                res(response.data);
            }).catch(function (error) {
                rej(error);
                console.error(error)
            });
    })
}

export const submitUserQuery = (QueryData) => {
    return new Promise((res, rej) => {
        APISERVICE.POST(`${process.env.NEXT_PUBLIC_CUSTOMER}/enquiries`, QueryData)
            .then((response) => {
                res(response.data);
            }).catch(function (error) {
                rej(error);
                console.error(error)
            });
    })
}

export const sendOTP = (userDetails) => {
    return new Promise((res, rej) => {
        APISERVICE.POST(`${process.env.NEXT_PUBLIC_CUSTOMER}/otp`, userDetails, { 'check': "OK" })
            .then((response) => {
                res(response);
            }).catch(function (error) {
                rej(error);
                console.error(error)
            });
    })
}

export const verifyAndRegister = (userDetails, OTP) => {
    return new Promise((res, rej) => {
        APISERVICE.POST(`${process.env.NEXT_PUBLIC_CUSTOMER}/verifyAndRegister?otp=${OTP}`, userDetails, { 'check': "OK" })
            .then((response) => {
                res(response);
            }).catch(function (error) {
                rej(error);
                console.error(error)
            });
    })
}
